import { useEffect } from "react";
import { SFDC_AUTH_CALLBACK_RESPONSE } from "../consts";

export const useSfdcAuthenticationCallback = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authorizationCode = urlParams.get("code");
    const error = urlParams.get("error");
    const errorDescription = urlParams.get("error_description");

    const callbackResponse = {
      authorizationCodeGrant: authorizationCode,
      error: error || errorDescription,
    };

    // Store the response in localStorage to communicate with the parent window
    localStorage.setItem(
      SFDC_AUTH_CALLBACK_RESPONSE,
      JSON.stringify(callbackResponse)
    );

    // Close the popup window
    if (window.opener) {
      window.close();
    }
  }, []);
};
